import Vue from 'vue';
import store from '@/store';
import * as types from './mutation-types';
import MainInfoProxy from "../../../proxies/MainInfoProxy";

/**
 * 기본정보 저장
 * @param commit
 * @param param
 */
export const createMainInfo = ({ commit }, param) => {
  new MainInfoProxy()
    .create(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        // store.dispatch('settingsAuthority/findAll');
      } else {
        alert(response.header.resultMessages);
      }
    });
};

export default {
  createMainInfo
};
